import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from "prop-types"
import i18n from 'i18n/index.js'

function Post(props){
  
  const [post, setPost] = useState(props.post);

  return (
        
    <article className="post-grid">	
        {post.cover_f &&
            <figure>
                <a href={post.url} title="View Details" target="_blank" rel="noopener noreferrer">
                    <img className="lazyload" 
                    src={post.cover_f}
                    data-original={post.cover_f}/>
                </a>
            </figure>
        }
        <div className="info-slide oi-flex oi-flex-column">
            <p className="zone h7">{post.label}</p>
            <h3><a href={post.url} title="View Details" target="_blank" rel="noopener noreferrer">{post.title}</a></h3>
            <p className="subtile h5">
                {post.subtitle} 
            </p>
            <p className="author h7">
                <strong>{post.author_name} </strong> | {post.author_sm}
            </p>
            {/* <p className="date">
                {post.created_at_f} 
            </p> */}
        </div>
    </article>

  
  );
}

export default Post